var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconJobsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3083 7.4H14.6834",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31665 7.4L5.94165 8.025L7.81665 6.15",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3083 13.2333H14.6834",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31665 13.2333L5.94165 13.8583L7.81665 11.9833",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 18.3333H12.5001C16.6667 18.3333 18.3334 16.6667 18.3334 12.5V7.5C18.3334 3.33333 16.6667 1.66667 12.5001 1.66667H7.50008C3.33341 1.66667 1.66675 3.33333 1.66675 7.5V12.5C1.66675 16.6667 3.33341 18.3333 7.50008 18.3333Z",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconJobsInactive);
export default __webpack_public_path__ + "static/media/menu_icon_jobs_inactive.ed8d8ad5ab9898d7022f8b6aa5ff781e.svg";
export { ForwardRef as ReactComponent };